import { Box, Text } from '@factorialco/deprecated-design-system'
import type { Currency } from 'dinero.js'

import i18n from 'modules/core/lib/i18n'

import CompareText from '../CompareText'

export interface Summary {
  name: string
  subtitle?: string
  amountCurrentPeriod: number
  amountPreviousPeriod?: number
  currency: Currency
}
interface Props {
  summaryAmountList: Array<Summary>
}

const SummaryAmountList = ({ summaryAmountList }: Props) => {
  return (
    <Box
      width="full"
      borderRadius={{ all: 'abs008' }}
      border={{
        all: { width: 's1', style: 'solid', color: 'grey400' },
      }}
    >
      {summaryAmountList.map(
        ({ name, subtitle, amountCurrentPeriod, amountPreviousPeriod, currency }, index) => (
          <Box
            flexDirection="column"
            alignItems="flexEnd"
            padding="s16"
            gap="s4"
            key={index}
            border={{
              top: index === 0 ? undefined : { width: 's1', style: 'solid', color: 'grey400' },
            }}
          >
            <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" width="full">
              <Text.Normal size="300" color="grey800" weight="normal">
                {name}
              </Text.Normal>
              <Text.Normal size="300" color="grey800" weight="medium">
                {i18n.formatNumber(amountCurrentPeriod / 100, 'currency', currency)}
              </Text.Normal>
            </Box>
            <Box alignSelf="flexStart">
              <Text.Normal size="100" color="grey800">
                {subtitle}
              </Text.Normal>
            </Box>
            {amountPreviousPeriod && (
              <CompareText
                amount={Math.ceil(amountCurrentPeriod - amountPreviousPeriod)}
                currency={currency}
              />
            )}
          </Box>
        )
      )}
    </Box>
  )
}

export default SummaryAmountList
